import { css } from '@emotion/core'

export default ({ theme: { colors } }) => css`
  height: 50px;
  overflow: hidden;

  .track {
    height: 65px;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;

    > .item {
      display: inline-flex;
      align-items: center;
      height: 50px;
      margin-right: 0.3rem;
      padding: 0 0.5rem;
      background: ${colors.bg4};
      color: ${colors.body};
    }
  }
`
